import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminMyEmployees() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin My Employees page</h1>
                </div>
            </div>
        </>
    )
}
